import React from 'react';
import {
  ActionIconProps, Badge, Card, DetailStack, Grid,
} from '@doveit/bricks';
import { formatEuro, formatPercentage } from '@doveit/hammer';
import { Commission } from '../../../providers/api/dtos';
import { commissionTypeLabels } from '../../../labels';
import { ViewAgentSmallPreview } from '../../../agent/components';

export interface InvoiceCommissionCardProps extends React.AriaAttributes {
  title: string,
  commission: Commission,
  actions?: React.ReactElement<ActionIconProps>[]
}

const InvoiceCommissionCard: React.FC<InvoiceCommissionCardProps> = ({
  title,
  commission,
  actions = [],
  'aria-label': ariaLabel = 'invoice-commission-card',
}) => (
  <Card aria-label={ariaLabel}>
    <Card.Header
      title={title}
      primaryActions={actions}
    />
    <Card.Content>
      <Grid gutter={75}>
        <Grid.Unit>
          <ViewAgentSmallPreview agentIdOrEmail={commission.agentId} size="S" />
        </Grid.Unit>
        <Grid.Unit size={1 / 3}>
          <Badge label={commissionTypeLabels[commission.type]} size="XS" />
        </Grid.Unit>
        <Grid.Unit size={1 / 3}>
          <DetailStack label="Percentuale">{formatPercentage(commission.percentage)}</DetailStack>
        </Grid.Unit>
        <Grid.Unit size={1 / 3}>
          <DetailStack label="Importo">{formatEuro(commission.amount)}</DetailStack>
        </Grid.Unit>
      </Grid>
    </Card.Content>
  </Card>
);

export default InvoiceCommissionCard;
